export const wholesalerContactInfoAgentEmailCopy =
  "<p>Put the client's info here. As an agent, you get an automatic copy of this quote via email.</p>";

export const wholesalerContactInfoCoverageAccuracy =
  "<p>It's important to be as accurate as possible so we* can provide the coverage that's right for you.</p>";
